module.exports = __webpack_public_path__ + "static/Remote-467cd27c9f37ae6732dd54ae890f6c9f.mp4";